import React from 'react'
import Title from '../layouts/Title'
import { projectOne, projectTwo, projectThree, projectFour, projectFive, projectSeven } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND SEND YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="SAVI SAVINGS APP"
          des="Savi Savings is a web app that allows users to achieve their saving goals and set 
                target toward achieving a saving objective. It also has features to allow users 
                join and create saving groups.                   
                Technologies Used: C# and ASP.NET Core 6 for the backend, Reactjs for Frontend, Postgres, Entity Framework Core for ORM, 
                Cloudinary Service, Asp.Net core Identity, Firebase, Paystack Integration, HangFire, 
                Bootstrap, Redux, Moq"
          src={projectOne}
          githubLink="https://github.com/Tbossun/Savi-App"
          websiteLink="https://savi-savings.web.app/"
        />
        <ProjectsCard
          title="SNACKIES"
          des="An Asp.net e-commerce web App for an online Snack store where users can 
          select and place orders for various snacks.
          **Technologies Used - C#,web forms, ASP.NET 4.8, Stored Procedures, 
          Bootstrap, Asp.Net core Identity, Paystack, Bootstrap,ITextSharp"
          src={projectTwo}
          githubLink="#"
          websiteLink="https://agbacoder.bsite.net/User/Default.aspx"
        />
        <ProjectsCard
          title="FILMZIES"
          des="Filmzies is a simple yet advance movie search websites. This app integrates themovie.org Api into a .Net web API and integrates the api into a reactjs frontend
          Technologies Used - C#, Reactjs, JavaScript, SqlServer, Entity framework core"
          src={projectThree}
          githubLink="#"
          websiteLink="https://filmzies.vercel.app"
        />
        <ProjectsCard
          title="Curriculum Management System"
          des="Curriculum management system is a fullstack .Net Application utilizing the power of Asp.Net web Api alongside ASP.Net Mvc for the frontend. 
          This app allows for effective management of curriculum and courses at Decagon. 
          Technologies Used - C#, ASP.Net Web Api, Asp.net MVC, JavaScript, Entity framework, ASP.Net Identity, Postgres"
          src={projectFive}
          githubLink="#"
          websiteLink="#"
        />
        <ProjectsCard
          title="Opulence E-commerce Website"
          des=" A simple robust and scalable e-commerce system that uses Nest.js. Allowing for seemless shopping experience and basic Crud operations based on User Roles.
          Technologies Used - Nodejs, Typescript, Handlebars, JavaScript, TypeORM, Express, Postgres, BCrypt"
          src={projectFour}
          githubLink="#"
          websiteLink="#"
        />
        <ProjectsCard
          title="Agbacoder blog"
          des=" A blog site created using Nextjs and contentLayer."
          src={projectSeven}
          githubLink="#"
          websiteLink="https://next-blog-tbossuns-projects.vercel.app/"
        />
      </div>
    </section>
  );
}

export default Projects